import { defineComponent as _defineComponent } from 'vue'
import { AdminLanguage } from "@/common/types";
import i18n, { availableLocales } from "@/plugins/vue-i18n";
import ToolbarAdminLanguageDialog from "@/components/toolbar/admin/ToolbarAdminLanguageDialog.vue";

import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolbarAdminLanguage',
  setup(__props) {

const toolbarAdminLanguageDialog = ref();

const currentLocale = computed((): AdminLanguage | undefined =>
  availableLocales.find((i: AdminLanguage) => i.code === i18n.locale),
);
const computedAvailableLocales = computed((): AdminLanguage[] =>
  availableLocales.filter((i: AdminLanguage) => i.code !== i18n.locale),
);

function openToolbarLanguageDialog(locale: string): void {
  toolbarAdminLanguageDialog.value.open(locale);
}

return { __sfc: true,toolbarAdminLanguageDialog, currentLocale, computedAvailableLocales, openToolbarLanguageDialog, ToolbarAdminLanguageDialog }
}

})